<template>
  <div class="bg-gray">
    <div class="form-content">

      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="姓名"
                prop="name"
                :rules="[
                {
                  required: true,
                  message: '请输入姓名',
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                  v-model="formData.name"
                  placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="num"
                          :rules="[
      { required: true,validator: validator.idCard, message: '请输入身份证号', trigger: 'blur'},
    ]"
            >
              <el-input
                  type="text"
                  placeholder="请输入身份证号"
                  v-model="formData.num"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
                label="所属单位"
                prop="danwei"
                :rules="[
                { required: true, message: '单位名称不能为空', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="formData.danwei"
                  type="text"
                  placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="formData.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="身份证照片" prop="pic">
              <PicUploader :fileList="formData.pic" :limit="2"></PicUploader>
              <div class="form-label-desc">上传身份证正面、背面照片</div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
                label="手机"
                prop="phone"
                :rules="[
                {
                  required: true,
                  validator: validator.phone,
                  message: '请输入正确的手机号',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                  v-model="formData.phone"
                  placeholder="请输入正确的手机号"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
                label="邮箱"
                prop="email"
                :rules="[
                {
                  required: true,
                  validator: validator.email,
                  message: '请输入正确的邮箱',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                  v-model="formData.email"
                  placeholder="请输入邮箱"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                label="微信"
                prop="weixin"
                :rules="[
                {
                  required: true,
                  message: '请输入微信',
                  trigger: ['blur'],
                },
              ]"
            >
              <el-input
                  v-model="formData.weixin"
                  placeholder="请输入微信"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">保存
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>

      <YundongyuanPicker
          :show="showYundongyuanPicker"
          :limit="30"
          @onChange="onYundongyuanChange"
          @onClose="showYundongyuanPicker=false"
          :defaultValue="formData.yundongyuan"
          @onConfirm="onYundongyuanConfirm"
      ></YundongyuanPicker>
      <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

    </div>
  </div>
</template>
<style scoped>

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}

.kaojicenter-list-box {
  padding-top: 0.2rem;
  /*background: rgba(248,248,248,1);*/
}

.goods-line {
  height: 55px;
}

.goods-bottom-line {
  width: 100%;
  position: fixed;
  height: 60px;
  bottom: 0;
  background: linear-gradient(180deg, hsla(255, 0%, 100%, 0), #fff);
}

.goods-create-btn {
  position: fixed;
  bottom: 10px;
  width: 100%;
  height: 44px;
  font-size: 16px;
  text-align: center;
}

.goods-create-btn button {
  width: 3.2rem;
}

.goods-create-btn img {
  width: 60px;
  height: 60px;
}

.goods-header {
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  margin-bottom: 0.01rem;
  background: #fff;
}

.van-tabs {
  /*width: 85% !important;*/
}

.screen-btn {
  line-height: 44px;
  height: 44px;
}

.screen-btn img {
  width: 45%;
  padding-left: 15px;
  vertical-align: middle;
  border-left: 1px solid #D5D5D5;
}

.sidebar {
  padding-top: 15px;
}

.search-box img {
  width: 60px;
  height: 60px;
}


.select-btn {
  position: fixed;
  bottom: 0;
  width: 90%;
  margin: 0 auto;
  padding: 0px 15px 30px;
}

.btn-reset {
  padding-bottom: 10px;
}

.btn-reset >>> .van-button {
  background: #ddd;
}

.selected {
  color: #444;
}


.kaojicenter-lists {
  padding: 0.2rem;
  border-radius: 10px;
  background: #fff;
  margin: 0 0.2rem 0.2rem;
}

.kaojicenter-lefts {
  position: relative;
}


.kaojicenter-lefts .img {
  border-radius: 10px;
  width: 1rem;
  height: 1rem;
}

.kaojicenter-rights {
  width: calc(100% - 1.2rem);
  position: relative;
  height: 1rem;
}

.kaojicenter-rights .title {
  font-size: 15px;
  font-weight: bold;
}

.kaojicenter-rights .desc {
  font-size: 12px;
  padding-top: 10px;
  color: #999;
}

.row-list {
  border-bottom: 0.1rem solid #EFEFEF;
  background: #fff;
  margin: 0.2rem;
  border-radius: 0.2rem;
}

.row-title-img {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.1rem;
}

.row-title {
  padding: 0.1rem 0.33rem;
}

.title-right {
  color: #FD2840;
}


.row-left {
  width: 80%;
}

.row-right {
  text-align: center;
}

.goods-detail {
  width: 72%;
}

.row-left-img {
  width: 1.44rem;
  height: 1.44rem;
  border-radius: 5px;
  margin-right: 0.2rem;
}

.row-goods {
  padding: 0.2rem 0.3rem;
  border-bottom: 1px solid #EFEFEF;
}

.goods-name {
  /*font-size: 12px;*/
  margin-bottom: 0.2rem;
}

.goods-price {
  font-size: 16px;
  margin: 0.1rem 0 0.6rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(253, 40, 64, 1);
}

.goods-price span {
  font-size: 12px;
}

.goods-num {
  font-size: 12px;
}

.pay_order {
  width: 87px;
  height: 26px;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  margin-right: 0.5rem
}

.row-btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0.2rem 0.33rem;
  font-size: 12px;
  text-align: center;
  line-height: 0.52rem;
}

.look-order {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 26px;
  width: 75px;
  height: 26px;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  margin-right: 0.5rem;
}

.invite-btn {
  width: 2.1rem;
  height: 0.52rem;
  background: rgba(255, 0, 0, 1);
  border: 1px solid rgba(255, 0, 0, 1);
  border-radius: 4px;
  color: #fff;
}
</style>

<script>
import Vue from 'vue';
import validator from "../../../utils/validator";
import IdCardPicker from "../../../components/picker/IdCardPicker.vue";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';
import YundongyuanPicker from '@/components/picker/YundongyuanSkillPicker.vue';

import {
  Cell,
  CellGroup,
  Toast,
  Dialog,
  Icon,
  PullRefresh,
  List,
  Tag,
  Button,
  DropdownMenu,
  DropdownItem,
  DatetimePicker
} from 'vant';
import area from "../../../utils/area";
import LoginDialog from '@/components/LoginDialog.vue';

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(DropdownItem).use(DatetimePicker);
export default {
  name: 'AbilityApplyMemberAdd',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    IdCardPicker,
    PicUploader,
    FileUploader,
    YundongyuanPicker,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      id: 0,
      active: 0,
      loginShow: false,
      showDate: false,
      showArea: false,
      showGradePicker: false,
      showYundongyuanPicker: false,
      showOldGradePicker: false,
      showOldProjectPicker: false,
      actionShow: false,
      addShow: false,
      list: [],
      areaOptions: [],
      areaList: {},
      row: {},
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker: false,
      numTypeColumns: ['身份证', '护照', '其他身份证明'],
      oldGradeColumns: ['无', '一星级', '二星级', '三星级', '四星级', '五星级'],
      gradeColumns: ['一星级', '二星级', '三星级', '四星级', '五星级'],
      oldProjectColumns: ['无', '花球啦啦操', '街舞啦啦操', '技巧啦啦操'],
      projectColumns: [ '花球啦啦操', '街舞啦啦操', '技巧啦啦操'],
      actions: [
        {name: '隐藏'},
        {name: '认证'},
      ],
      params: {
        pageNo: 1,
        pageSize: 10,
        keywords: '',
        cate_id: 0,
        is_show: 1
      },
      formData: {
        name: '',
        num: '',
        minzu: '',
        huzhao: '',
        cardtype: 1,
        birthday: '',
        sex: 1,
        zhengjianimg: [],
        pic: [],
        attsrc: [],
      },
      saveLoading: false,
      isLoading: false,
      loading: false,
      finished: false,

    }
  },
  mounted() {
    document.title = "能力测试运动员备案"
    this.getAreaOptions();
  },
  computed: {},
  filters: {
  },
  destroyed() {
  },
  methods: {
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (res) => {
        that.areaOptions = res.data;
        that.namekeyList = res.data;
      });
    },
    handleAreasChange(values) {
      let data = this.$refs.areas.getCheckedNodes()[0].pathLabels;
      console.log("handleAreasChange", values, data);
      this.formData.area = values[2];
      this.formData.namekey = values[2];
      this.formData.province = data[0];
      this.formData.city = data[1];
      this.formData.county = data[2];
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.getList();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },
    onYundongyuanConfirm(values) {
      this.showYundongyuanPicker = false;
      this.formData.yundongyuan = [...values];
    },
    onYundongyuanChange(values) {
      console.log('onYundongyaunChange', values)
      this.formData.yundongyuan = [...values];
    },
    toCert() {
      rbLink({
        name: 'LevelApplyMemberList'
      })
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.namekey = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },

    onOldGradeConfirm(value) {
      this.formData.year = value;
      this.showOldGradePicker = false;
    },

    // 上拉加载
    // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
    // 可以延迟异步的时间
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log('this.params.pageNo')

      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.getList()
        }, 500);
      }

    },

    onCopy(e) {
      Toast.success('复制成功');
    },
    onError(e) {
      console.log('复制失败！');
    },

    // 分享给家长
    onShareParent() {
      let that = this
      appEvent({
        name: 'shareWeixinFriend',
        query: that.share_data
      });
    },

    download(file, name=''){
      appEvent({
        name: 'downloadFile',
        query: {
          name: name,
          url: file
        }
      });
    },


    action(item, index) {

      this.actionShow = true;
      this.params.id = item.id;
      this.params.name = item.name;
      this.actions = [];
      if (item.is_show == 1) {
        this.actions.push({name: '隐藏'});
      } else {
        this.actions.push({name: '显示'});
      }
      if (item.cert_status == 2) {
        this.actions.push({name: '认证'});
      } else {
      }

    },
    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },

    onDateConfirm(date) {
      console.log('onDateConfirm', date);
      this.showDate = false;
      this.formData.birthday = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    submit() {

    },
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.cardtype = index + 1;
      this.showNumTypePicker = false;
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    onFamilyIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.jianhuname = data.name;
      this.formData.jianhunum = data.cardNum;
    },
    onIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.name = data.name;
      this.formData.num = data.cardNum;
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName]);
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData);
          that.formValidate = true;
          for (let field in that.formData) {

            if (!this.formData.pic.length) {
              that.$message.warning('请上传身份证照片');
              return
            }

          }
          that.saveLoading = true;
          that.$api.post('/api/ability/memberApply', that.formData, (res) => {
                that.saveLoading = false;
                that.addShow = false;
                that.formData = {
                  name: '',
                  danwei: '',
                  num: '',
                  phone: '',
                  email: '',
                  weixin: '',
                  sex: 1,
                  pic: [],
                };
                that.$message.success('新增成功')
                rbLink({
                  name: 'AbilityApplyList'
                })
              },
              (res) => {
                that.$message.warning(res.msg);
                that.saveLoading = false;
              }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {
        if (!this.formData.namekey) {
          Toast('请选择所属地区');
          return
        }

        if (!this.formData.shenfenzheng_pic.length) {
          Toast('请上传身份证照片');
          return
        }

        if (!this.formData.yundongyuan.length) {
          Toast('请选择人员');
          return
        }
      }
      that.saveLoading = true;
      that.$api.post('/api/yundongyuan/skillLevelApply', that.formData, (res) => {
        that.saveLoading = false;
        that.addShow = false;
        that.formData = {
          year: '', name: '', danwei: '', namekey: '', province: '', city: '', county: '', shenfenzheng_pic: [],
          phone: '', weixin: '', email: '', address: '', yundongyuan: []
        };
        Toast.success('申报成功')
        that.onRefresh()
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    onTongbu() {
      let that = this;
      that.$api.post('/api/yundongyuan/tongbuCca', {}, (res) => {
        Toast(res.msg);
        that.onRefresh();
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    // 更改状态
    onStatusChange(index) {

      let that = this;
      that.params.is_show = index + 1;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      this.$route.query.is_show = 0;
      that.getList()
    },


  }
}
</script>



// WEBPACK FOOTER //
// AbilityApplyMemberAdd.vue?81bf37be